import React, {useState,useEffect} from 'react';
import {ErrorReport, Unsupported, Failure, ProjectNotFound} from './fail.js';

import moment from 'moment';
import {connect} from 'react-redux';
import { setHistoryData } from '../../state/actions/app.js';



const RefreshReport=({display})=>{
	return(
        display?
    		<div className="row top-box rounded-lg" id="refresh-dialog">
                <div className="alert alert-info suggest" role="alert">
                    <h4>We are refreshing this Report - Reload this page in 5 minutes to see the results</h4>
                    Our reporting engine has just started analyzing this codebase. Depeding on the complexity of the project
                    and on the load on the platform,
                    it can take 2-10 minutes to complete it. <u>Is your project building correctly?</u> Projects that are
                    not building correctly take significantly more time
                    to analyze, so make sure everything is fine!<br/>
                    Don't hesitate to contact us at <a href="mailto:support@meterian.com">support@meterian.com</a> if you
                    need more information.
                </div>
            </div>
        : null
	)
}

const Suggest=({display,url})=>{
    return(
        display?
            <div className="row top-box" id="suggest">
                <div className="alert alert-info alert-dismissible suggest" role="alert">
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span>
                    </button>
                    <h4>Add the Security and Stability badges to your Github project!</h4>
                    <a id="suggest-link" href={`/badges.html?gh=${url}`} target="_blank" rel="noopener noreferrer" ><u>Get here</u></a> the code to add to your README.md file on Github
                    to display the Security and Stability badges
                </div>
            </div>
        :null
    )
}



const mapNavigatorStateAsProps = state =>({
    historyData : state.historyData,
    history: state.historyData.history || [],
    displayNavigator: (state.historyData.history && state.historyData.history.length) || false,
    reportError: state.projectInfo.reportError,
    reportUuid: state.projectInfo.report.uuid
})

const mapNavigatorDispatchAsProps = dispatch => ({
    setHistoryData: (data)=>dispatch(setHistoryData(data))
})


let reportIndex = 0;

const NavigatorComponent =({loadPage,history,reportError,displayNavigator,historyData, setHistoryData, reportUuid})=>{
   
    
    const [reports,setReports] = useState([]);
    useEffect(()=>{
        (async()=>{
            const reportsSummary = history;
            setReports(reportsSummary)
        })()
    },[])
    for (let i = 0; i < reports.length; i++){
        const report = reports[i]
        if ( report.uuid === reportUuid ){
            reportIndex = i
        }
    }

    if(reportError || !displayNavigator) return ""

    const chooseReport = async(e)=>{
        reportIndex=e.target.value*1;
        setHistoryData({selected: reports[reportIndex].uuid})
        await loadPage(reports[reportIndex].uuid,reportIndex===0)
    }

    const Pagination = ()=>{


        // setTimeout(()=>$("#navigation-selector").selectpicker(),0);
        return (
            <select defaultValue={reportIndex} onChange={chooseReport} id="navigation-selector" className="btn dropdown-toggle btn-light">
                {
                    reports.map((report,index)=>{
                        const weeksFromNow = (Date.now() - report.timestamp)/(3600*1000*24*7);
                        const secondsFromDate = (Date.now()/1000)-(report.timestamp/1000);
                        const date = weeksFromNow<1?moment().subtract(secondsFromDate,'seconds').calendar():new Date(report.timestamp).toLocaleString()
                        const reportIndicator = index===0?"Latest":date
                        return <option key={reportIndicator+index} value={index}>{reportIndicator}</option>
                    })
                }
            </select>
        )
    }
    return(
        history.length>1 && reports.length?
        <span className="branches d-xs-none d-sm-none d-md-inline">
            Current report: <Pagination/>
        </span> 
        :""
    )
}



const ScrollBox =({security, stability, licensing,mitigations})=>{

    return(
        <div className="scrollBox">
            <a href="#root" title="Summary">
                <i className="scrollBtn fa fa-arrow-up"></i>
            </a><br/>
            {security?<span id="defects-scroll">
                <a tabIndex="0" href="#defects-row" title="SECURITY ASSESSMENT">
                    <i className="scrollBtn fas fa-shield-alt"></i>
                </a>
                <br/>
            </span>:null}
            {!security && mitigations?<span id="defects-scroll">
                <a tabIndex="0" href="#mitigations-row" title="SECURITY ASSESSMENT">
                    <i className="scrollBtn fas fa-shield-alt"></i>
                </a>
                <br/>
            </span>:null}
            {stability?<span id="versions-scroll">
                <a tabIndex="0" href="#versions-row" title="STABILITY ASSESSMENT">
                    <i className="scrollBtn far fa-newspaper"></i>
                </a>
                <br/>
            </span>:null}
            {licensing?<span id="licenses-scroll">
                <a tabIndex="0" href="#licenses-row" title="LICENSING ASSESSMENT">
                    <i className="scrollBtn fas fa-book"></i>
                </a>
                <br/>
            </span>:null}
        </div>
    ) 
}













class Fail extends React.Component{
    constructor(props){
        super(props)
        this.state={
            error: false,
            unsupported: false,
            failure: false
        }
    }
    componentDidMount(){
        const {status}=this.props
        switch(status){
            case "UNSUPPORTED":{
                this.setState({unsupported:true});
                break;
            } 
            case "ERROR":{
                this.setState({failure: true});
                break;
            }
            case "NOT FOUND":{
                this.setState({error: true});
                break;
            }
            case "FAILED":{
                this.setState({error: true});
                break;
            }
            case status!=="OK":{
                this.setState({error: true});
                break;
            }
            default:{}

        }
    }
    render(){
        const {error, unsupported, failure, notFound}=this.state;
        return(
            <div className="row">
                <div className="col-md-8 mt-5">
                    <ErrorReport display={error} />
                    <Unsupported display={unsupported}/>
                    <Failure display={failure}/>
                    <ProjectNotFound display={notFound}/>
                </div>
            </div>
        )
    }
}




const Navigator = connect(mapNavigatorStateAsProps, mapNavigatorDispatchAsProps)(NavigatorComponent);







export {RefreshReport,Suggest, ScrollBox, Fail, Navigator}